import { Add } from "@mui/icons-material";
import { Button, Grid2 as Grid, Typography } from "@mui/material";
import { FC, useState } from "react";
import { Can } from "src/shared/lib/rback/Can";
import { IPartnerContactDTO } from "src/shared/types/partner.types";
import { AddContactModal } from "../EditContactModal/AddContactModal";
import { ContactPersonItem } from "./ContactPersonItem";
interface IContactPersonsProps {
  contactPersons: IPartnerContactDTO[];
}
export const ContactPersons: FC<IContactPersonsProps> = ({
  contactPersons,
}) => {
  const [isAddContactModalOpen, setIsAddContactModalOpen] = useState(false);

  return (
    <Grid container spacing={4}>
      <Grid
        size={12}
        sx={{
          order: -2,
        }}
      >
        <Typography
          sx={{
            color: "grey.500",
          }}
        >
          Контакты
        </Typography>
      </Grid>
      {contactPersons.map((contactPerson) => {
        return (
          <Grid
            size={12}
            key={contactPerson.id}
            sx={{
              order: contactPerson.is_main_contact ? -1 : 1,
            }}
          >
            <ContactPersonItem contactPerson={contactPerson} />
          </Grid>
        );
      })}
      {contactPersons.length > 1 && (
        <Grid
          size={12}
          sx={{
            order: 0,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "grey.500",
            }}
          >
            Дополнительные контактные лица:
          </Typography>
        </Grid>
      )}
      <Grid
        size={12}
        sx={{
          order: 1,
          marginBottom: "1.25rem",
        }}
      >
        <Can perform={["partners.edit", "partners.edit.team"]}>
          <Button
            variant="outlined"
            onClick={() => setIsAddContactModalOpen(true)}
            endIcon={<Add />}
          >
            Добавить
          </Button>
        </Can>
        {isAddContactModalOpen && (
          <AddContactModal
            open
            onClose={() => setIsAddContactModalOpen(false)}
          />
        )}
      </Grid>
    </Grid>
  );
};
